seedWebApp.controller('ChangeOrderModalController', ['$scope', '$uibModalInstance', 'ToastService', 'StoreService', 'TranslationService', 'item',
    function ($scope, $uibModalInstance, ToastService, StoreService, TranslationService, item) {

        $scope.item = item;
        $scope.translation = TranslationService.getActiveTranslation();
        
        $scope.loadStatusChangeable = function (order) {
            StoreService.getStatusChangeable(order.OrderID).then(
                function (result) {
                    $scope.statusTypes = result.data.map(function (item) {
                        return {
                            Group: item.Group,
                            Key: item.Key,
                            Value: $scope.translation['Status_' + item.Value]
                        }
                    });
                }
            );
        };

        $scope.loadStatusChangeable(item);

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $scope.loading = true;
                        
            var changes = {
                orderID: $scope.item.OrderID,
                statusID: $scope.item.StatusID,
                cancelReason: $scope.item.CancelReason,
                completeComments: $scope.item.CompleteComments,
            };
            if (!changes.statusID || changes.statusID == '') {
                ToastService.createToast('Erro', 'Falta selecionar o novo status', 2000, 'error');
                return;
            }

            var toastID = ToastService.createToast($scope.translation.SavingLoad, '', 4000, 'wait');            
            StoreService.saveOrderChanges(changes).then(
                function () {
                    $scope.loading = false;
                    ToastService.updateToast(toastID, $scope.translation.ActionSuccessfullySaved, '', 4000, 'success');
                    $uibModalInstance.close();
                },
                function (error) {
                    $scope.loading = false;
                    console.log('save error: ');
                    console.log(error.data);
                    var errorMsg = error.data.Message;
                    var errorExc = error.data.ExceptionMessage;
                    ToastService.updateToast(toastID, $scope.translation.ErrorSaving, '', 4000, 'error');
                } 
            );                       

        };
    }
]);